import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 5px;
`;

export const WrapperInputCustom = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

export const Column = styled.div`
  flex: 1;
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #7b7b7b;
  margin-bottom: 6px;
  display: block;
`;

